import styled from "styled-components";
import { theme } from "../../theme";
import { Flex } from "@mantine/core";
import {
  ArrowTrendingUpIcon,
  ArrowTrendingDownIcon,
} from "@heroicons/react/24/outline";
import { Container } from "./StyledComponents";
import SvgIcon from "../common/Icons/SvgIcon";
import { ReactComponent as AverageIcon } from "../../assets/average.svg"

const InfoBox = ({
  title,
  Icon,
  flex,
  data,
}: {
  title: string;
  Icon: any;
  flex: any;
  data: any;
}) => {
  const colors = [
    {
      background: "#ECFDF3",
      color: theme.colors.alert.green,
    },
    {
      background: "#FFFAEB",
      color: theme.colors.alert.orange,
    },
    {
      background: "#FEF3F2",
      color: theme.colors.alert.red,
    },
  ];

  const icons = [
    <ArrowTrendingUpIcon color={colors[data?.status]?.color} height={20} />,
    <SvgIcon Icon={AverageIcon} color={colors[data?.status]?.color} width={20} />,
    <ArrowTrendingDownIcon color={colors[data?.status]?.color} height={20} />,
  ];
  return (
    <Container $flex={flex}>
      <Flex align={"center"} gap={8}>
        <IconWrapper>{Icon}</IconWrapper>
        <Title>{title}</Title>
      </Flex>
      <Flex align={"center"} justify={"space-between"}>
        <Count>{data?.count}</Count>
        {data?.percent !== undefined && data?.percent !== 0 && (
          <Badge
            $bg={colors[data?.status]?.background}
            $color={colors[data?.status]?.color}
          >
            {icons[data?.status]}
            <PercentageText>{data?.percent}</PercentageText>
          </Badge>
        )}
      </Flex>
      <Flex>{data?.message && <BoxTime>{data?.message}</BoxTime>}</Flex>
    </Container>
  );
};

export default InfoBox;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  border-radius: 3.6px;
  background: ${theme.colors.secondary.blue.light};
`;

const Title = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #200d59;
`;

const Count = styled.div`
  font-weight: 600;
  font-size: 28px;
  line-height: 32px;
  color: ${theme.colors.greyscale.black};
`;

const PercentageText = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
`;

const BoxTime = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.colors.greyscale.gray80};
`;

const Badge = styled.div<{ $bg: any; $color: any }>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  height: 32px;
  width: 93px;
  border-radius: 40px;
  background-color: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
`;
